import {Box, Clickable, Text, VStack} from 'platform/foundation';

import {KeyboardEvent} from 'react';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {suffixTestId, TestIdProps} from 'shared/web';

interface BpmScenarioTileProps extends TestIdProps {
  label: string;
  value: string;
  note?: string;
  isSelected: boolean;
  onSelect: () => void;
}

const NON_BREAKING_SPACE = '\u00a0';

export function BpmScenarioTile(props: BpmScenarioTileProps) {
  // Kept in both tiles so they sit side by side at the same height.
  const note = isNotNilOrEmpty(props.note) ? props.note : NON_BREAKING_SPACE;

  // Clickable renders a plain div and only forwards these, so without them the
  // switcher would be reachable by mouse alone.
  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      props.onSelect();
    }
  };

  return (
    <Box flex={1}>
      <Clickable
        onClick={props.onSelect}
        onKeyDown={handleKeyDown}
        tabIndex={0}
        role="button"
        aria-pressed={props.isSelected}
        aria-label={`${props.label} ${props.value}`}
        data-testid={suffixTestId('scenario', props)}
      >
        <Box
          padding={3}
          border="1px solid"
          borderRadius="small"
          borderColor={props.isSelected ? 'palettes.blue.60.100' : 'palettes.neutral.40.100'}
          backgroundColor={props.isSelected ? 'palettes.blue.10.100' : 'general.white'}
        >
          <VStack>
            <Text size="xxSmall" color="tertiary">
              {props.label}
            </Text>
            <Text size="small" alternative data-testid={suffixTestId('scenarioValue', props)}>
              {props.value}
            </Text>
            <Text size="xxSmall" color="tertiary">
              {note}
            </Text>
          </VStack>
        </Box>
      </Clickable>
    </Box>
  );
}
